import $ from "jquery";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/widgets/autocomplete";
import "bootstrap-sass";
import "moment";
import "fullcalendar";
import "./professional.css";
import iconRaw from "!!raw-loader!legacy-icons/style.css";

$(document).ready(function () {
    //$('[data-toggle=tooltip]').tooltip();

    $("#lcsg-tb-datepicker").datepicker({
        showWeek: true,
        minDate: -20,
        maxDate: "+1M +10D"
    });

    $($("#lcsg-btn-datepicker")).click(function () {
        $("#lcsg-tb-datepicker").datepicker("show");
    });

    $(function () {
        const availableTags = [
            "ActionScript",
            "AppleScript",
            "Asp",
            "BASIC",
            "C",
            "C++",
            "Clojure",
            "COBOL",
            "ColdFusion",
            "Erlang",
            "Fortran",
            "Groovy",
            "Haskell",
            "Java",
            "JavaScript",
            "Lisp",
            "Perl",
            "PHP",
            "Python",
            "Ruby",
            "Scala",
            "Scheme"
        ];

        $("#lcsg-autocomplete").autocomplete({
            source: availableTags
        });
    });

    $("body").scrollspy({ target: "#lcsg-nav", offset: 100 });

    const lines = iconRaw.split("\n");
    const icons = [];

    let html = $("<div class='row'></div>");

    for (let i = 0; i < lines.length; i++) {
        if (lines[i].indexOf(".lc-icon-") != -1) {
            const icon = lines[i].substring(1, lines[i].indexOf(":"));

            if (html.children().length < 3) {
                html.append(
                    "<div class='col-sm-4'><span class='" +
                        icon +
                        "' title='" +
                        icon +
                        "'></span><span>" +
                        icon +
                        "</span></div>"
                );
            } else {
                html = $("<div class='row'></div>");
                html.append(
                    "<div class='col-sm-4'><span class='" +
                        icon +
                        "' title='" +
                        icon +
                        "'></span><span>" +
                        icon +
                        "</span></div>"
                );
            }

            icons.push(html);
        }
    }

    $("#lcsg-section-icons-all").append(icons);

    $(".lcsg-section-fullcalendar > div").fullCalendar({
        // put your options and callbacks here
        header: {
            left: "prev,next, title",
            center: "",
            right: "today agendaDay,agendaWeek,month,listWeek"
        },
        defaultView: "agendaWeek",
        defaultDate: "2017-02-12",
        navLinks: false, // can click day/week names to navigate views
        editable: true,
        eventLimit: true, // allow "more" link when too many events
        events: [
            {
                title: "All Day Event",
                start: "2017-02-01"
            },
            {
                title: "Long Event",
                start: "2017-02-07",
                end: "2017-02-10"
            },
            {
                id: 999,
                title: "Repeating Event",
                start: "2017-02-09T16:00:00"
            },
            {
                id: 999,
                title: "Repeating Event",
                start: "2017-02-16T16:00:00"
            },
            {
                title: "Conference",
                start: "2017-02-11",
                end: "2017-02-13"
            },
            {
                title: "Meeting",
                start: "2017-02-12T10:30:00",
                end: "2017-02-12T12:30:00"
            },
            {
                title: "Lunch",
                start: "2017-02-12T12:00:00"
            },
            {
                title: "Meeting",
                start: "2017-02-12T14:30:00"
            },
            {
                title: "Happy Hour",
                start: "2017-02-12T17:30:00"
            },
            {
                title: "Dinner",
                start: "2017-02-12T20:00:00"
            },
            {
                title: "Birthday Party",
                start: "2017-02-13T07:00:00"
            },
            {
                title: "Click for Google",
                url: "https://google.com/",
                start: "2017-02-28"
            }
        ],
        slotDuration: { minutes: 15 },
        slotLabelInterval: { hours: 1 },
        slotEventOverlap: false,
        allDayText: "",
        nowIndicator: true
    });
});
